if (!customElements.get('quick-checkout-button')) {
  const closeIcon = `<svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;

  class QuickCheckoutButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-quick-checkout-button]');
      this.errorsContainer = this.querySelector('[data-cart-errors-container]');
      this.section = this.closest('[data-section-type]') || document;

      this.onClick = this.onClick.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);

      this.button?.addEventListener('click', this.onClick);
      this.section.addEventListener('theme:variant:change', this.onVariantChange);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.section.removeEventListener('theme:variant:change', this.onVariantChange);
    }

    onVariantChange(event) {
      const variant = event.detail?.variant;

      if (variant) this.dataset.variantId = variant.id;
      this.button.disabled = !variant || !variant.available;
      this.hideError();
    }

    getFormData() {
      const form = document.getElementById(this.dataset.formId);
      const formData = form ? new FormData(form) : new FormData();

      if (!formData.get('id')) formData.set('id', this.dataset.variantId);
      if (!formData.get('quantity')) formData.set('quantity', 1);

      return formData;
    }

    async onClick(event) {
      event.preventDefault();

      if (this.button.disabled) return;

      this.hideError();
      this.button.disabled = true;
      this.button.classList.add('is-loading');

      try {
        const response = await fetch(`${window.theme.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json'},
          body: this.getFormData(),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw data;
        }

        window.location.href = `${window.theme.routes.root || '/'}checkout`;
      } catch (error) {
        this.showError(error);
        this.button.disabled = false;
        this.button.classList.remove('is-loading');
      }
    }

    showError(error) {
      if (!this.errorsContainer) return;

      const message = error?.message || window.theme?.strings?.error || 'Something went wrong';
      const description = error?.description;
      const text = description && description !== message ? `${message}: ${description}` : message;

      this.errorsContainer.innerHTML = `<div class="errors">${text}<button type="button" class="errors__close" data-close-error>${closeIcon}</button></div>`;
      this.errorsContainer.classList.add('is-visible');
      this.errorsContainer.querySelector('[data-close-error]')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.hideError();
      });
    }

    hideError() {
      this.errorsContainer?.classList.remove('is-visible');
    }
  }

  customElements.define('quick-checkout-button', QuickCheckoutButton);
}
